import script from "./MetadataForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MetadataForm.vue?vue&type=script&setup=true&lang=js"

import "./MetadataForm.vue?vue&type=style&index=0&id=1bf265fd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf265fd"]])

export default __exports__